import { createRouter } from "@tanstack/react-router";
import NotFound from "@/components/blocks/not-found";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const getRouter = () => {
	const router = createRouter({
		routeTree,
		scrollRestoration: true,
		defaultPreload: "intent",
		// Cache for 5 seconds
		defaultStaleTime: 5000,
		defaultPreloadStaleTime: 5000,
		// Garbage collect after 5 minutes
		defaultGcTime: 5 * 60 * 1000,
		notFoundMode: "root",
		defaultNotFoundComponent: NotFound,
		trailingSlash: "always",
	});

	return router;
};
